<template>
  <div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">&times;</button>
    <h4 class="modal-title">{{ title }}</h4>
  </div>
</template>

<script>
export default {
  name: 'modal-header',
  props: {
    title: {
      type: String,
      required: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Modal/ModalHeader.vue